var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"role":"button"},on:{"click":_vm.toggleButton}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"transition mdi mdi-chevron-right mdi-24px",class:{
                'clicked': _vm.isClicked
            }})])])
}
var staticRenderFns = []

export { render, staticRenderFns }